<script setup lang="ts">
const { t } = useI18n();
const { percent: topSplitPercent } = useTopSplitPercent();

const emit = defineEmits<{
  (e: 'sign-up'): void;
  (e: 'how-it-works'): void;
}>();
</script>

<template>
  <div
    class="mt-8 flex flex-wrap items-center justify-between gap-7 rounded-[20px] bg-gradient-to-br from-[#0d0f15] to-[#1a1c24] px-10 py-9 text-white"
  >
    <div class="min-w-0 flex-1">
      <div class="mb-2 font-mono text-[10px] font-bold uppercase tracking-[0.1em] text-gold-primary-100">
        {{ t('property.access.guestBottomCTA.eyebrow') }}
      </div>
      <h2
        class="m-0 mb-2.5 max-w-[640px] font-serif text-[32px] font-semibold leading-[1.15] tracking-[-0.02em] text-white"
      >
        {{ t('property.access.guestBottomCTA.heading', { percent: topSplitPercent }) }}
      </h2>
      <p class="m-0 text-[14px] text-white/70">
        {{ t('property.access.guestBottomCTA.sub') }}
      </p>
    </div>
    <div class="flex shrink-0 gap-2.5">
      <button
        type="button"
        class="inline-flex h-[52px] items-center rounded-[12px] bg-gold-primary-100 px-6 text-[15px] font-bold text-black-100 shadow-[0_8px_22px_rgba(255,182,72,0.3)] transition-colors hover:bg-gold-primary-120"
        @click="emit('sign-up')"
      >
        <span
          >{{ t('property.shell.signUpFreeArrow') }}
          <span
            class="inline-block rtl:-scale-x-100"
            aria-hidden="true"
            >→</span
          ></span
        >
      </button>
      <button
        type="button"
        class="inline-flex h-[52px] items-center rounded-[12px] border border-white/25 px-[22px] text-[14px] font-semibold text-white transition-colors hover:bg-white/[0.06]"
        @click="emit('how-it-works')"
      >
        {{ t('property.access.guestBottomCTA.howItWorks') }}
      </button>
    </div>
  </div>
</template>
